import {Grid} from '@mui/material';

import {PreviewSection} from '../../components/PreviewSection/PreviewSection';

export const OrganizationPreview = ({organization}) => (
  <Grid container spacing={4}>
    <PreviewSection label="Organization Name:" value={organization.name} />
  </Grid>
);
